import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ObservatoryService, StorageService } from '@services/services.module';
import { ProjectsService } from '@services/projects/projects.service';
import { CalendarService } from '@components/calendar/calendar.service';
import { DayData } from '@components/calendar/calendar-day/calendar-day.model';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { APP_URLS } from '@app/constants/app-urls';
import { SearchInputDynamicComponent } from '@components/search-input-dynamic/search-input-dynamic.component';

@Component({
  selector: 'app-gestion-empleados-imputacion',
  templateUrl: './gestion-empleados-imputacion.component.html',
  styleUrls: ['./gestion-empleados-imputacion.component.scss']
})
export class GestionEmpleadosImputacionComponent implements OnInit, OnDestroy {
  @ViewChild('dynamic_search_empleado') dynamic_search_empleado: SearchInputDynamicComponent;
  public listEmployee: any;
  public employee = 0;
  public APP_URLS = APP_URLS;
  public userData: any;
  public dayListToMonth: Array<DayData>;
  public show;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private projectsService: ProjectsService,
    public calendarService: CalendarService,
    private router: Router,
    private observatory: ObservatoryService, private storage: StorageService
  ) {
    window.scrollTo(0, 0);
    this.observatory.setData('loader', true);
    // forzar eliminar el ultimo elemento buscado en el buscador
    this.observatory.setData('idItemList', '');
    this.show = false;
  }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });

    this.show = false;
    this.userData = this.storage.get('userDataStorage');
    this.employee = 0;
    if (!this.storage.get('allProjects')) {
      this.projectsService.getProjects(this.userData.employeeNumber).subscribe((proyectData) => {
        if (proyectData) {
          if (!this.storage.get('listProjectsByEmployee')) {
            proyectData.sort((a, b) => {
              if (a.description < b.description) { return -1; }
              if (a.description > b.description) { return 1; }
              return 0;
            });
            proyectData.map((item) => {
              item.campoCompleto = item.sapId + ' ' + item.description;
              item.Id = item.projectId;
              return item;
            });
            this.observatory.setData('proyectos', proyectData);
            this.storage.set('listProjectsByEmployee', proyectData);
            this.storage.set('allProjects', true);
          }
        }
      });
    }
  }

  routeTo(route) {
    this.router.navigate([route]);
  }

  takeEmploye(data) {
    if (!data.Id) {
      this.employee = 0;
      data.Id = 0;
    } else {
      this.observatory.setData('employeeNumber', data.Id);
      this.employee = data.Id;
    }
    let currentDate;
    let month;
    let year;
    this.observatory.setData('changeEmployee', data);
    this.observatory.getData('CalendarYearDate').subscribe(val => {
    currentDate = val.initDate;
    });
    month = currentDate.substring(4, 6);
    year = currentDate.substring(0, 4);
    this.calendarService.getCalendar(
      this.employee,
      year,
      month
    )
      .subscribe(val => {
        this.dayListToMonth = val;
        this.observatory.setData('dayListToMonth', this.dayListToMonth);
        this.observatory.setData('employeeId', this.employee);
      });
    this.show = true;
  }

  cancel() {
    this.employee = 0;
  }

  ngOnDestroy(): void { }

}
